module.exports = __webpack_public_path__ + "img/11_112.13fac349.png";